const getStatusStyle = (status) => {
  const statusLower = status?.toLowerCase() || "";
  if (statusLower.includes("go") || statusLower.includes("confirmed")) return "status-go";
  if (statusLower.includes("tbd") || statusLower.includes("tbc")) return "status-tbd";
  if (statusLower.includes("hold") || statusLower.includes("scrub")) return "status-hold";
  return "status-tbd";
};

export const LaunchHeroImage = ({ launch }) => {
  if (!launch.image) return null;

  return (
    <div className="relative h-48 md:h-64 overflow-hidden">
      <img
        src={launch.image}
        alt={launch.rocket}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-space-black via-space-black/50 to-transparent" />
      <div className="absolute bottom-4 left-4 right-4">
        <span className={`status-badge ${getStatusStyle(launch.status)}`}>
          {launch.status}
        </span>
      </div>
    </div>
  );
};
